export default "__VITE_ASSET__CzN9wdo6__"